import BaseComponent from '../../js/base-component';

export default class LanguageComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.trigger = this.refs.trigger;

        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.ip_country = this.getCookie(ct_ip);

    }

    static getRequiredRefs(){
        return ['trigger'];
    }

    init(){
        this.getIpCookie();
        this.trigger.addEventListener('click', this.onTriggerClick);
    }

    onTriggerClick(e){
    }

    getCookie(name) {
        let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    }

    isRu(ip_country){
        if (ip_country !== null && ip_country == 'RU') {
            this.element.classList.add('is-ru');
        }
    }

    async getIpCookie() {
        if (this.ip_country !== null) {
            this.isRu(this.ip_country);
        } else {
            const response = await fetch('https://api.cleantalk.org/?method_name=ip_info&ip=' + ct_ip);
            const apiData = await response.json();

            if(ct_ip && apiData.data[ct_ip].country_code) {
                this.ip_country = apiData.data[ct_ip].country_code;
                this.getCookie(ct_ip, this.ip_country, { expires : 30 });
                this.isRu(this.ip_country);
            }
        }
    }

    onDestroy(){
        this.trigger.removeEventListener('click', this.onTriggerClick);
    }
}
